"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Permission;
(function (Permission) {
    Permission["Read"] = "Read";
    Permission["Write"] = "Write";
    Permission["Admin"] = "Admin";
})(Permission = exports.Permission || (exports.Permission = {}));
function isSufficientPermission(permission, minimum) {
    if (permission === Permission.Admin) {
        return true;
    }
    else if (minimum === Permission.Write && permission === Permission.Write) {
        return true;
    }
    else if (minimum === Permission.Read) {
        return true;
    }
    else {
        return false;
    }
}
exports.isSufficientPermission = isSufficientPermission;
